import React from 'react';
import { CalendarWeekProps } from '../../types';
import {
  nullFn,
  addDaysToCalendar,
  isEqualDate,
  isDateWithinRange,
  shouldDateBeSelected,
} from '../../utils';
import CalendarDay from './CalendarDay';
import { useCalendar } from './Calendar';

export default function CalendarWeek({
  value = undefined,
  minValue = undefined,
  maxValue = undefined,
  startDate,
  endDate,
  firstOfMonth,
  lastOfMonth,
  onChange = nullFn,
}: CalendarWeekProps): JSX.Element {
  const { currentRange, selectionType, selectedRange } = useCalendar();
  const daysDiff = endDate.getDay() - startDate.getDay() + 1;
  const days = Array.from(Array(daysDiff), (item, idx) => {
    const date = addDaysToCalendar(startDate, idx);
    return (
      <CalendarDay
        date={date}
        firstOfMonth={firstOfMonth}
        key={`${idx}_day`}
        minValue={minValue}
        maxValue={maxValue}
        onChange={onChange}
        isSelected={shouldDateBeSelected(
          date,
          value,
          selectionType,
          selectedRange,
        )}
        isFirstDayOfWeek={idx === 0 || isEqualDate(date, firstOfMonth)}
        isLastDatOfWeek={idx === 6 || isEqualDate(date, lastOfMonth)}
        isWithinRange={isDateWithinRange(date, currentRange)}
      />
    );
  });
  return <tr>{days}</tr>;
}
